export const isBetaUser = ({ _role = '', _slug = '' }) => {
  return true;
  // // insert user.slug value into this list to grant access
  //   const TIMED_ENTRY_WHITELISTED_USER_SLUGS = [
  //     'K5NS4H', // WEB-12742: Immersive: Van Gogh - Chicago (ticketing@vangoghchicago.com)
  //     'X23QNW', // WEB-12742: Illusionarium (ticketing@illusionarium.ca)
  //     'KR05JF', // WEB-12843: Van Gogh - San Francisco
  //     'RZSKCQ', // Museum of Illusions - Chicago
  //     'Y7PX4B', // WEB-13069: Van Gogh - Los Angeles
  //     '4T7MS9', // WEB-13069: Van Gogh - Chicago
  //     'ZXVWP7', // WEB-13100: Starvox - New York
  //     '39B48N', // WEB-13078: Starvox - Test
  //     'S714JV', // WEB-13157: Van Gohh - Dallas
  //     'FK03CB', // WEB-13157: Van Gogh - Boston
  //     'ZT4G18', // WEB-13157: Van Gogh - Vegas
  //     'MYZC3W', // WEB-13157: Van Gogh - Philadelphia
  //     '8CBN39', // WEB-13157: Van Gogh - Phoenix
  //     'LZY3KW', // WEB-13157: Van Gogh - Seattle
  //     'TW31DY', // WEB-13157: Van Gogh - Miami
  //     'QYDX97', // WEB-13157: Van Gogh - Houston
  //     '3GV6CZ', // WEB-13157: Van Gogh - Denver
  //     '67SJH1', // WEB-13157: Van Gogh - Minneapolis
  //     'P4F0S8', // WEB-13157: Van Gogh - DC
  //     'TZNB04', // WEB-13157: Van Gogh - Austin
  //     'L5FVR1', // WEB-13174: Starvox's IVG - Pittsburgh
  //     'BMV59Y', // WEB-13220: Starvox's IVG - Cleveland
  //     'HXF95D', // WEB-13221: Starvox's Lighthouse Immersive Art
  //     'J6N3CB', // WEB-13237: Starvox's - classes@vangoghchicago.com
  //     '0K5QYD', // WEB-13241: Grant Metrix (WallJam)
  //     'F1NV8R', // WEB-13252: Starvox - Spare1@VanGoghChicago.com
  //     'BJQDSN', // WEB-13252: Starvox - Spare2@VanGoghChicago.com
  //     '713QJB', // WEB-13252: Starvox - Spare3@VanGoghChicago.com
  //     'HB6KM3', // WEB-13252: Starvox - Spare4@VanGoghChicago.com
  //     'RTGB59', // WEB-13252: Starvox - Spare5@VanGoghChicago.com
  //     '513C7L', // WEB-13252: Starvox - Spare6@VanGoghChicago.com
  //     '6M2ZQT', // WEB-13252: Starvox - Spare7@VanGoghChicago.com
  //     'QS17PZ', // WEB-13252: Starvox - Spare8@VanGoghChicago.com
  //     'W8LQ6Z', // WEB-13252: Starvox - Spare9@VanGoghChicago.com
  //     'WKZ934', // WEB-13337: Starvox - jason@starvoxent.com
  //     '7ZVRJQ', // WEB-13604: AM/PM Entertainment - ampm@universe.com
  //     'NYP382', // WEB-13595: Starvox - ticketing+A@starvoxent.com
  //     '6LCFSQ', // WEB-13595: Starvox - ticketing+B@starvoxent.com
  //     'PQJ5L1', // WEB-13595: Starvox - ticketing+C@starvoxent.com
  //     'X6MBVH', // WEB-13595: Starvox - ticketing+D@starvoxent.com
  //     'T3KXBZ', // WEB-13595: Starvox - ticketing+E@starvoxent.com
  //     '9WQXMS', // WEB-13595: Starvox - ticketing+F@starvoxent.com
  //     '6Y4WLG', // WEB-13595: Starvox - ticketing+G@starvoxent.com
  //     '9CXSWT', // WEB-13595: Starvox - ticketing+H@starvoxent.com
  //     'PWY0QX', // WEB-13595: Starvox - ticketing+I@starvoxent.com
  //     '9THQC4', // WEB-13595: Starvox - ticketing+J@starvoxent.com
  //     'XG51JF', // WEB-13595: Starvox - ticketing+K@starvoxent.com
  //     '5BQWMK', // WEB-13595: Starvox - ticketing+L@starvoxent.com
  //     '7546J2', // WEB-13595: Starvox - ticketing+M@starvoxent.com
  //     'RGBLT9', // WEB-13595: Starvox - ticketing+N@starvoxent.com
  //     'D6HRJQ', // WEB-13595: Starvox - ticketing+O@starvoxent.com
  //     'P3D81Z', // WEB-13595: Starvox - ticketing+P@starvoxent.com
  //     'ZDX4C1', // WEB-13595: Starvox - ticketing+Q@starvoxent.com
  //     'W4LYP3', // WEB-13595: Starvox - ticketing+R@starvoxent.com
  //     '2XR1QD', // WEB-13595: Starvox - ticketing+S@starvoxent.com
  //     '8NXHSF', // WEB-13595: Starvox - ticketing+T@starvoxent.com
  //     'PS7NRH', // WEB-13595: Starvox - ticketing+U@starvoxent.com
  //     'N2X7ZH', // WEB-13595: Starvox - ticketing+V@starvoxent.com
  //     '3KYBWF', // WEB-13595: Starvox - ticketing+W@starvoxent.com
  //     'XF70H4', // WEB-13595: Starvox - ticketing+X@starvoxent.com
  //     '24MG6K', // WEB-13595: Starvox - ticketing+Y@starvoxent.com
  //     '76MBD5', // WEB-13595: Starvox - ticketing+Z@starvoxent.com
  //     'B9VXQN', // WEB-13595: Starvox - universe@starvoxent.com
  //     'ZWVC50', // WEB-13666: AMP - info@artmarketproductions.com
  //     '5LT2HB', // WEB-13708: Grammy Museum Experience - guestservices@prucenter.com
  //     'V4M2L3', // WEB-13728: Secret Cinema US - secretus@universe.com
  //     'XNVQ1W', // WEB-13728: Christmas in Color - South Jordan, UT  - sojo@christmasincolor.net
  //     'YX4FDL', // WEB-13728: Christmas in Color - Shakopee, MN  - valleyfair@chirstmasincolor.net
  //     '5BH0G4', // WEB-13728: Christmas in Color - San Dimas, CA - sandimas@christmasincolor.net
  //     '6DXKF0', // WEB-13728: Christmas in Color - Federal Heights, CO - waterworld@christmasincolor.net
  //     'TW8CY3', // WEB-13728: Christmas in Color - Morrison, CO - bandimere@christmasincolor.net
  //     'DKFV3H', // WEB-13728: Christmas in Color - Garden City, ID -  boise@christmasincolor.net
  //     '81DMJ5', // WEB-13759: Next Exhibition Spain S.L. - infonextexhibition@gmail.com
  //     'YTDQ5C', // WEB-13796: North Pole Experience Dublin - northpoleexperience@gmail.com
  //     'S0J1BL', // WEB-13798: Joe Gallagher Entertainments - marketing@joegallagherentertainments.com
  //     'ZPLFV1', // WEB-13814: BRIC - ticketing@bricartsmedia.org
  //     'RM6KFG', // WEB-13793: Nutcracker Boston - ticketing.boston@immersive-nutcracker.com
  //     '85KFRP', // WEB-13793: Nutcracker Chicago - ticketing.chicago@immersive-nutcracker.com
  //     'KV5HQ6', // WEB-13793: Nutcracker Cleveland - ticketing.cleveland@immersive-nutcracker.com
  //     '5FG6ZC', // WEB-13793: Nutcracker Dallas - ticketing.dallas@immersive-nutcracker.com
  //     'VZX6YF', // WEB-13793: Nutcracker Houston - ticketing.houston@immersive-nutcracker.com
  //     'M9N4QS', // WEB-13793: Nutcracker Las Vegas - ticketing.vegas@immersive-nutcracker.com
  //     'VW891J', // WEB-13793: Nutcracker Minneapolis - ticketing.msp@immersive-nutcracker.com
  //     'RH5XZT', // WEB-13793: Nutcracker NYC - ticketing.nyc@immersive-nutcracker.com
  //     '4PFB7T', // WEB-13793: Nutcracker Phoenix - ticketing.phx@immersive-nutcracker.com
  //     'JLZW7Y', // WEB-13793: Nutcracker Pittsburgh - ticketing.pittsburgh@immersive-nutcracker.com
  //     '7ND8Q5', // WEB-13793: Nutcracker San Francisco - ticketing.sf@immersive-nutcracker.com
  //     '35CV0R', // WEB-13793: Nutcracker Toronto - ticketing.toronto@immersive-nutcracker.com
  //     'CR9H5W', // WEB-13855: 313 Presents Magic of Lights - boxofficemanagers@olyent.com
  //     'VT3ZHP', // WEB-13855: 313 Presents Magic of Lights - esmee.robinson+mol2021@universe.com (tmp)
  //     '6427P8', // WEB-13864: Christmas in Color - Allentown, PA - allentown@christmasincolor.net
  //     '7KQSP9', // WEB-13864: Christmas in Color - Kissimmee, FL - Kissimmee@christmasincolor.net
  //     'VY5KRN', // WEB-13864: Christmas in Color - Federal Way, WA - Federalway@christmasincolor.net
  //     '6FMQ7H', // WEB-13864: North Pole Festival - SLC, UT - riotinto@northpolefestival.com
  //     'R5P7VQ', // WEB-13873: Shelby Farms Park Conservancy - shop@shelbyfarmspark.com
  //     'F75SQX', // WEB-13897: SB-Ops BV - info@xpospace.be
  //     'X3SR8P', // WEB-13898: The GAA Museum - jclarke@crokepark.ie
  //     '0X8NL6', // WEB-13899: SillyBilly - info@sillybilly.ie
  //     'PT6L51', // WEB-13905: Magnolia - events@magnolia.com
  //     '3S0GF6', // WEB-13918: Creative Kitchen - creativekitchen@universe.com
  //     '3G1XD8', // WEB-13919: Chill in the Park - chill@universe.com
  //     '957VCH', // WEB-13931: Tucutucu Producciones Culturales - info@tucutucu.es
  //     '7N4651', // WEB-13933: Findlay Toyota Center - lynette.crowe@spectraxp.com
  //     'WN2KSX', // WEB-13936: Houstonopoly - houstonopoly@gmail.com
  //     'NLYMHC', // WEB-13951: Tucson Ice Rink - peggy.nelson@tucsonaz.gov
  //     'T7VLH3', // WEB-13956: REVOLT/Superfly - alicia.guyton@superf.ly
  //     '2PWVK7', // WEB-13968: Circuit of the AMericas(COTA) - cota@universe.com
  //     '0VCMSW', // WEB-13967: American Bank Center - tixinfo.americanbankcenter@cctexas.com
  //     '460Q21', // WEB-13979: New Orleans Ernest N. Morial Convention Center - kcalabrese@mccno.com
  //     '9ZBW4S', // WEB-13982: CARABOOM - caraboom@universe.com
  //     'YK19HR', // WEB-14022: Paley Center - paleycenter@universe.com
  //     'FM8SN2', // WEB-14024: Carnica Veranstaltungen - veranstaltungen@carnica.de
  //     'JLY0MP', // WEB-14041: Regina Exhibition Associated Ltd (REAL) - tia.macneil@real1884.ca
  //     'FC6HRY', // WEB-14101: Luna Ventures Ltd - sean@thelunacinema.com
  //     'GJ3BW6', // WEB-14107:	1SPARE - ticketing+1@lighthouseimmersive.com
  //     'PC32H8', // WEB-14107:	2SPARE - ticketing+2@lighthouseimmersive.com
  //     'FMHSB8', // WEB-14107:	3SPARE - ticketing+3@lighthouseimmersive.com
  //     'C3GN4K', // WEB-14107:	4SPARE - ticketing+4@lighthouseimmersive.com
  //     'K5BD60', // WEB-14107:	5SPARE - ticketing+5@lighthouseimmersive.com
  //     'KCVMGH', // WEB-14107:	6SPARE - ticketing+6@lighthouseimmersive.com
  //     '9K0F4H', // WEB-14107:	7SPARE - ticketing+7@lighthouseimmersive.com
  //     '9BSDV1', // WEB-14107:	8SPARE - ticketing+8@lighthouseimmersive.com
  //     'CWHR79', // WEB-14107:	9SPARE - ticketing+9@lighthouseimmersive.com
  //     'GNWJCB', // WEB-14107:	10SPARE - ticketing+10@lighthouseimmersive.com
  //     'QH9NFJ', // WEB-14107:	11SPARE - ticketing+11@lighthouseimmersive.com
  //     'GLM4BD', // WEB-14107:	12SPARE - ticketing+12@lighthouseimmersive.com
  //     '1S6PN9', // WEB-14107:	13SPARE - ticketing+13@lighthouseimmersive.com
  //     'XT8F1Z', // WEB-14107:	14SPARE - ticketing+14@lighthouseimmersive.com
  //     'C2TQD7', // WEB-14107:	15SPARE - ticketing+15@lighthouseimmersive.com
  //     'PL89VK', // WEB-14107:	16SPARE - ticketing+16@lighthouseimmersive.com
  //     '4CV6D0', // WEB-14107:	17SPARE - ticketing+17@lighthouseimmersive.com
  //     'WYFL3Q', // WEB-14107:	18SPARE - ticketing+18@lighthouseimmersive.com
  //     'L8W2Q9', // WEB-14107:	19SPARE - ticketing+19@lighthouseimmersive.com
  //     'R5Y89T', // WEB-14107:	20SPARE - ticketing+20@lighthouseimmersive.com
  //     '4JPT5K', // WEB-14107:	21SPARE - ticketing+21@lighthouseimmersive.com
  //     'D9YMGW', // WEB-14107:	22SPARE - ticketing+22@lighthouseimmersive.com
  //     'R948CQ', // WEB-14107:	23SPARE - ticketing+23@lighthouseimmersive.com
  //     'Y93TMG', // WEB-14107:	24SPARE - ticketing+24@lighthouseimmersive.com
  //     'Y86XCG', // WEB-14107:	25SPARE - ticketing+25@lighthouseimmersive.com
  //     'XLM9C8', // WEB-14107:	26SPARE - ticketing+26@lighthouseimmersive.com
  //     '7J4ZK6', // WEB-14107:	27SPARE - ticketing+27@lighthouseimmersive.com
  //     '90WLKC', // WEB-14107:	28SPARE - ticketing+28@lighthouseimmersive.com
  //     'GCWMKQ', // WEB-14107:	29SPARE - ticketing+29@lighthouseimmersive.com
  //     'LP92B8', // WEB-14107:	30SPARE - ticketing+30@lighthouseimmersive.com
  //     'V4J7SR', // WEB-14107:	31SPARE - ticketing+31@lighthouseimmersive.com
  //     '6WHF8L', // WEB-14107:	32SPARE - ticketing+32@lighthouseimmersive.com
  //     'VFKYBQ', // WEB-14107:	33SPARE - ticketing+33@lighthouseimmersive.com
  //     'LQ09J5', // WEB-14107:	34SPARE - ticketing+34@lighthouseimmersive.com
  //     '7246WL', // WEB-14107:	35SPARE - ticketing+35@lighthouseimmersive.com
  //     '287T9L', // WEB-14109:	Megara Inc - megara@universe.com
  //     '96YHMZ', // WEB-14113: The Atlantic - atlantic@universe.com
  //     'GCMPZT', // WEB-14114: Museum of Illusions -  michaela.radman@icloud.com
  //     'FQN1JG', // WEB-14115: Action Sports - actionsports@universe.com
  //     'BTSY24', // WEB-14121: Catedral Burgos - historiabiertaburgos@gmail.com
  //     'VMQ46B', // WEB-14141: Factory 42 - william.rhysjones@factory42.uk
  //   ];

  // return (
  //   role === 'Admin' ||
  //   role === 'Super_admin' ||
  //   role === 'Developer' ||
  //   role === 'Sales' ||
  //   role === 'Sales_admin' ||
  //   TIMED_ENTRY_WHITELISTED_USER_SLUGS.includes(slug)
  // );
};

const EU_COUNTRIES = ['AX', 'AT', 'BE', 'DK', 'FI', 'DE', 'FR', 'IM', 'NL', 'ES', 'SE', 'GB'];

export const isEuCountry = (country) =>
  country ? EU_COUNTRIES.includes(country) : false;

export const emailValid = (value) =>
  value ? value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) : false;

export const stripTimezone = (date) => {
  const values = date.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);

  if (values instanceof Array) {
    values.shift();
    const [year, month, day, hour, minutes] = values.map(i => parseInt(i, 10));
    return new Date(year, (month - 1), day, hour, minutes);
  }

  return new Date(date);
}

export const sanitizeAmountInput = (input) => {
  let value;
  value = String(input);
  // remove all characters that aren't digit or dot
  value = value.replace(/[^0-9.]/g,'');
  // replace multiple dots with a single dot
  value = value.replace(/\.+/g,'.');
  // replace multiple zeros with a single one
  value = value.replace(/^0+(.*)$/,'0$1');
  // remove leading zero
  value = value.replace(/^0([^.].*)$/,'$1');
  return value;
}

export const sanitizeInputIntoInt = (value) => {
  const intValue = parseInt(value, 10);
  return value.length && !Number.isNaN(intValue) && intValue >= 0 ? intValue : '';
}

export const sanitizeInputIntoFloat = (value) => {
  if (value.length === 1 && value === '.') return '0.';
  return sanitizeAmountInput(value);
}

export const fixFloatingPointPrecision = (value) => {
  // Fixes floating point precision issues
  return value ? Number(value.toFixed(4)) : 0;
}
